import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Health of the marketplace pollers (Mercari favourites + PayPay negotiations).
// Superuser only on the backend. Read-only.
const getPollerHealth = async () => {
    return await axios.get(`${BACKEND_URL}/api/admin/poller-health`);
};

const PollerHealthService = {
    getPollerHealth,
};

export default PollerHealthService;
